import { render, staticRenderFns } from "./ColorPickerModal.vue?vue&type=template&id=6080bcd4&scoped=true"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerModal.vue?vue&type=style&index=0&id=6080bcd4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080bcd4",
  null
  
)

export default component.exports